import type { HttpPlugin, HttpResponse } from "@kalodata/http";
import { ClipHttpEnvelope } from "./types";

const isClipApiEnvelope = (value: unknown): value is ClipHttpEnvelope => {
  if (typeof value !== "object" || value === null) return false;
  const o = value as Record<string, unknown>;
  return typeof o.success === "boolean" && "data" in o;
};

/**
 * 把 `HttpResponse.data` 从包层 `{ success, data, ... }` 收窄为内层 `data`。
 *
 * `success === false` 时不剥壳，便于与 `createErrorPlugin` 配合：请把 `createErrorPlugin` 放在本插件**之前**，
 * 这样会先按包层抛出业务错误，再对成功响应做剥壳。
 */
export const createSlicePlugin = <TMeta = unknown, TContext = unknown>(): HttpPlugin<TMeta, TContext> => {
  return {
    name: "slice",
    onResponse: (response): HttpResponse<unknown, TMeta, TContext> => {
      const payload = response.data;
      if (!isClipApiEnvelope(payload) || !payload.success) {
        return response;
      }
      return { ...response, data: payload.data };
    },
  };
};
